import { app } from '../../../../app';
import { Controller } from './request-center-list.controller';

app.component('requestCenterList', {
    bindings: {
        requests: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./request-center-list.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/list/request-center-list.component.js